module.exports = __webpack_public_path__ + "img/bring-solutions.f54bc7de.svg";